export {
    IIMREditGrid,
    IMREditGridBeforeAddArgs,
    IMREditGridBeforeEditArgs,
    IMREditGridGetObjectIdArgs,
    IMREditGridInitializedArgs,
    IMREditGridOptions,
    IMREditGridSetObjectIdArgs,
    IMREditGridSubmitArgs,
} from './edit-grid/edit-grid.interfaces'
export { EDIT_GRID_MODULE_NAME } from './edit-grid.module'
